import { VueExtension } from '../../utils/extensions/vue';
import Mask from './mask.jsx';
import './mask.scss';

VueExtension.WithInstall(Mask);

export default Mask;
